import { DeleteOutlined } from '@ant-design/icons';
import { BasketballCoachLog } from '@hefe/models';
import { Button, Popconfirm, Space, Spin } from 'antd';
import { useAppDispatch } from '../../../../store/store';
import { t } from '@hefe/i18n';
import React, { useState } from 'react';
import { BasketballCoachLoggingSlice } from '@hefe/store';

interface CoachLoggingMoreActionsComponentProps {
  log: BasketballCoachLog;
}

export default function CoachLoggingMoreActionsComponent(
  props: CoachLoggingMoreActionsComponentProps
) {
  const dispatch = useAppDispatch();
  const [isDeleting, setDeleting] = useState(false);

  const deleteLog = () => {
    setDeleting(true);
    dispatch(
      BasketballCoachLoggingSlice.deleteBasketballCoachLogging(props.log)
    )
      .unwrap()
      .catch(() => null)
      .finally(() => setDeleting(false));
  };

  return (
    <Space>
      <Popconfirm
        title={t('delete') + '?'}
        onConfirm={() => deleteLog()}
        disabled={isDeleting}
      >
        <Button
          type="link"
          size="small"
          icon={isDeleting ? <Spin size="small" /> : <DeleteOutlined />}
        />
      </Popconfirm>
    </Space>
  );
}
